import { api } from 'app/api'
import { useCallback, useState } from 'react'
import { PUT_VENDING_MACHINES_EXTERNAL_SERVICES_SETTINGS, convertParams, convertResult } from 'app/common/api/requests/data/vending/machines/external_service_settings/service_id/put'
import {
  POST_VENDING_MACHINES_EXTERNAL_SERVICES_SETTINGS,
  convertParams as convertPostParams,
  convertResult as convertPostResult
} from 'app/common/api/requests/data/vending/machines/external_service_settings/post'

interface Options {
  machineId: number
}

type Props = {
  serviceId: number
  active: boolean
}
type PostProps = {
  enableExternalServices: boolean
}

export const useVendingMachineExtServicesSettingsMutate = ({ machineId }: Options) => {
  const [pending, setPending] = useState<boolean>(false)


  const updateService = useCallback(async ({ serviceId, active }: Props) => {
    if (!serviceId) return
    setPending(true)
    const res = await api.request(PUT_VENDING_MACHINES_EXTERNAL_SERVICES_SETTINGS, {
      error: 'Не удалось изменить настройки внешнего сервиса у машины вендинга',
      params: {
        machineId,
        serviceId: serviceId.toString(),
        active,
      },
      convertions: {
        convertParams,
        convertResult
      },
    })
    if (res) {
      setPending(false)
      return true
    }
    setPending(false)
    return false
  }, [machineId])

  const updateSettings = useCallback(async ({ enableExternalServices }: PostProps) => {
    setPending(true)
    const res = await api.request(POST_VENDING_MACHINES_EXTERNAL_SERVICES_SETTINGS, {
      error: 'Не удалось изменить настройки внешнего сервиса',
      params: {
        machineId,
        enableExternalServices,
      },
      convertions: {
        convertParams: convertPostParams,
        convertResult: convertPostResult
      },
    })
    if (res) {
      setPending(false)
      return true
    }
    setPending(false)
    return false
  }, [machineId])


  return {
    pending,
    updateService,
    updateSettings
  }
}
